import React from 'react'
import { Avatar } from 'transfix-ui/components/Avatar'
import { Button } from 'transfix-ui/components/Button'
import { makeStyles, Box, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useUserDetails } from 'utils/hooks/useUserDetails'

const useProfileMenuStyles = makeStyles(theme => ({
  root: {
    minWidth: 'auto',

    [theme.breakpoints.up('md')]: {
      minWidth: 245,
    },
  },
}))

const ProfileMenu = () => {
  const { logout, userDetails } = useUserDetails()
  const { firstName = '', lastName = '' } = userDetails || {}
  const fullName = [firstName, lastName].join(' ')
  const classes = useProfileMenuStyles()
  return (
    <div className={classes.root} data-test='ProfileMenu'>
      <Box display='flex' alignItems='center' pb={1.5}>
        <Box flex='0 0 auto' pr={1}>
          <Avatar name={fullName} hideShadow hideTooltip size='medium' />
        </Box>
        <Box flex='1 1 auto' color={brandColors.coolGray8}>
          <Typography variant='h3' component='div'>
            {fullName}
          </Typography>
        </Box>
      </Box>
      <div>
        <Button fullWidth color='primary' size='large' onClick={logout}>
          Sign Out
        </Button>
      </div>
    </div>
  )
}

export default ProfileMenu
